import React, { Component } from 'react';
import { OverlayTrigger, Tooltip as ReactTooltip } from 'react-bootstrap';
import { uuid } from 'util/baseUtil';

export default class Tooltip extends Component {
  tooltip = () => {
    return (
      <ReactTooltip id={`tooltip${uuid()}`}>{this.props.text}</ReactTooltip>
    );
  };

  render() {
    if (this.props.text && window.outerWidth > 767) {
      return (
        <OverlayTrigger
          placement={this.props.placement || 'top'}
          overlay={this.tooltip()}>
          {this.props.children}
        </OverlayTrigger>
      );
    } else {
      return this.props.children;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/util/tooltip/index.js